// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * QuestionAnswerSchema - Implements schema.org Question and Answer
  *
  * Describes a webpage
  *
  * @example
    <QuestionAnswerSchema data={data}>
  *
  * @param {string} data.question - Required. The question.
  * @param {string} data.questionDate - Required. The date the question was asked.
  * @param {string} data.answer - Required. The answer.
  * @param {string} data.answerDate - Required. The date the answer was given.
  * @param {string} data.answeringEntity - Required. Who gave the answer?
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/Question|Schema.org Question Docs}
  */
var QuestionAnswerSchema = function QuestionAnswerSchema(props) {
  var data = props.data;


  var schemaOrgJSONLD = {
    "@context": "http://schema.org",
    "@type": "Question",
    text: data.question,
    dateCreated: data.questionDate,
    suggestedAnswer: {
      "@type": "Answer",
      text: data.answer,
      dateCreated: data.answerDate,
      author: {
        "@type": "Organisation",
        name: data.answeringEntity
      }
    }
  };

  return React.createElement(
    Helmet,
    null,
    React.createElement(
      "script",
      { type: "application/ld+json" },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
};

QuestionAnswerSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

QuestionAnswerSchema.defaultProps = {
  data: {
    author: ""
  }
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default QuestionAnswerSchema;